'use client';

import React from 'react';

export function LoginSkeleton() {
  return (
    <div className="min-h-screen relative flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-[#0D373D]/50 animate-pulse" />

      <div className="w-full max-w-[1200px] h-[720px] bg-white/90 rounded-2xl shadow-[0_16px_50px_-12px_rgba(0,0,0,0.15)] overflow-hidden flex relative z-10">
        {/* Left Panel - Form Skeleton */}
        <div className="w-full lg:w-[60%] p-8 lg:p-12 flex flex-col">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 rounded-md bg-gray-200 animate-pulse" />
            <div className="h-6 w-32 rounded-md bg-gray-200 animate-pulse" />
          </div>

          <div className="flex-1">
            <div className="w-full max-w-[400px] mx-auto pt-6">
              <div className="h-10 w-64 rounded-md bg-gray-200 animate-pulse mb-3" />
              <div className="h-5 w-48 rounded-md bg-gray-200 animate-pulse mb-8" />

              <div className="space-y-5">
                <div className="h-12 w-full rounded-xl bg-gray-200 animate-pulse" />
                <div className="h-12 w-full rounded-xl bg-gray-200 animate-pulse" />
                <div className="flex justify-end">
                  <div className="h-5 w-32 rounded-md bg-gray-200 animate-pulse" />
                </div>
                <div className="h-12 w-full rounded-xl bg-gray-200 animate-pulse" />

                <div className="relative py-5">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-200"></div>
                  </div>
                  <div className="relative flex justify-center">
                    <div className="px-2 bg-white">
                      <div className="h-5 w-48 rounded-md bg-gray-200 animate-pulse" />
                    </div>
                  </div>
                </div>

                <div className="h-12 w-full rounded-xl bg-gray-200 animate-pulse" />
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel - Image Skeleton */}
        <div className="hidden lg:block w-[40%] relative overflow-hidden">
          <div className="absolute inset-0 bg-gray-200 animate-pulse" />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-300 via-gray-200 to-transparent" />
          <div className="absolute inset-0 flex items-end p-12">
            <div className="space-y-4 max-w-[320px]">
              <div className="h-16 w-48 rounded-md bg-gray-300 animate-pulse" />
              <div className="h-20 w-64 rounded-md bg-gray-300 animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
